"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibilityHidden = exports.unsetNoWrap = exports.startIcon = exports.positionRelative = exports.iconButton = exports.icon = exports.endIcon = exports.centerLoader = exports.buttonWithIcon = exports.buttonCompact = exports.buttonBlock = exports.button = exports.avatarButton = exports.LOADERSIZE = void 0;
require("./buttonStyles.css");
var _tokens = require("../tokens");
const LOADERSIZE = 24;
exports.LOADERSIZE = LOADERSIZE;
const button = "cds-button-bpih6bv";
exports.button = button;
const buttonCompact = "cds-buttonCompact-b17kdj8k";
exports.buttonCompact = buttonCompact;
const buttonBlock = "cds-buttonBlock-b90146d";
exports.buttonBlock = buttonBlock;
const iconButton = "cds-iconButton-i1804idl";
exports.iconButton = iconButton;
const avatarButton = iconButton;

// Need to add height here to contain the icon size or
// it will render 30px height making it look off center
exports.avatarButton = avatarButton;
const centerLoader = "cds-centerLoader-cb0ze3e";
exports.centerLoader = centerLoader;
const visibilityHidden = "cds-visibilityHidden-v1x4gmu6";
exports.visibilityHidden = visibilityHidden;
const positionRelative = "cds-positionRelative-p109mlw7";
exports.positionRelative = positionRelative;
const unsetNoWrap = "cds-unsetNoWrap-u1lgl550";
exports.unsetNoWrap = unsetNoWrap;
const buttonWithIcon = "cds-buttonWithIcon-bagbhaq";
exports.buttonWithIcon = buttonWithIcon;
const icon = `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
  flex-shrink: 0;
`;
exports.icon = icon;
const startIcon = "cds-startIcon-s1em2uz7";
exports.startIcon = startIcon;
const endIcon = "cds-endIcon-eejbfv9";
exports.endIcon = endIcon;